import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';

const useConsumerUnsubscribeToCause = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const deleteRequest = async ({ causeId, token }: { causeId?: string; token?: string }) => {
    const params = new URLSearchParams();
    if (causeId) params.set('cause_id', causeId);
    if (token) params.set('token', token);
    const { data } = await BackerApi.delete<{ status: string }>(
      `/consumer/communications/status?${params.toString()}`
    );
    return data;
  };

  return useMutation({
    mutationFn: deleteRequest,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.communicationStatus.all });
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.lists.all });
    },
  });
};

export { useConsumerUnsubscribeToCause };
